import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_SelfAdminMedObservationLog = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_SelfAdminMedObservationLog' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><center><h3>Self-Administered Medication Observation Log</h3></center></p>


                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Time/ Date <br />&nbsp; <br />&nbsp;</span></td>
                        <td className='w-150'><span className='eleHeader'>Medication <br />&nbsp; <br />&nbsp;</span></td>
                        <td className='w-150'><span className='eleHeader'>Dosage <br />&nbsp; <br />&nbsp;</span></td>
                        <td className='w-150'><span className='eleHeader'>Individual Signature <br />&nbsp;</span></td>
                        <td className='w-150'><span className='eleHeader'>Staff Observation Signature/ Credential</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_1' name='txtDateTime_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_1' name='txtDosage_1' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_2' name='txtDateTime_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_2' name='txtDosage_2' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_3' name='txtDateTime_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_3' name='txtDosage_3' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_4' name='txtDateTime_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_4' name='txtDosage_4' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_5' name='txtDateTime_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_5' name='txtDosage_5' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_6' name='txtDateTime_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_6' name='txtMedication_6' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_6' name='txtDosage_6' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_7' name='txtDateTime_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_7' name='txtMedication_7' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_7' name='txtDosage_7' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_8' name='txtDateTime_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_8' name='txtMedication_8' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_8' name='txtDosage_8' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_9' name='txtDateTime_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_9' name='txtMedication_9' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_9' name='txtDosage_9' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_10' name='txtDateTime_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_10' name='txtMedication_10' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_10' name='txtDosage_10' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_11' name='txtDateTime_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_11' name='txtMedication_11' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_11' name='txtDosage_11' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_12' name='txtDateTime_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_12' name='txtMedication_12' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_12' name='txtDosage_12' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_13' name='txtDateTime_13' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_13' name='txtMedication_13' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_13' name='txtDosage_13' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_14' name='txtDateTime_14' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_14' name='txtMedication_14' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_14' name='txtDosage_14' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_15' name='txtDateTime_15' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_15' name='txtMedication_15' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_15' name='txtDosage_15' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_16' name='txtDateTime_16' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_16' name='txtMedication_16' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_16' name='txtDosage_16' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_17' name='txtDateTime_17' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_17' name='txtMedication_17' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_17' name='txtDosage_17' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_18' name='txtDateTime_18' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_18' name='txtMedication_18' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_18' name='txtDosage_18' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_19' name='txtDateTime_19' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_19' name='txtMedication_19' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_19' name='txtDosage_19' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtDateTime_20' name='txtDateTime_20' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtMedication_20' name='txtMedication_20' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtDosage_20' name='txtDosage_20' className='add-only' /></td>
                        <td className='signature w-150'></td>
                        <td className='signature w-150'></td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











